<script>

import * as dayjs from "dayjs";
import {planyTerapiiService} from "@/services/planyTerapii.service";
import swal from "sweetalert";
import PlanZdrowieniaEdit from "@/components/clients/PlanZdrowieniaEdit.vue";


export default {
  name: "PlanyZdrowienia",
  components: {PlanZdrowieniaEdit},
  props: ["clientid"],
  data() {
    return {
      nowy_plan_dialog: false,
      items: [],
      options: {},
      pagination: {},
      totalCount: 0,
      edytowanyPlan: null,
      title_edycja_tworzenie: 'Nowy plan terapii i zdrowienia',
      headers: [
        { text: 'Realizacja', sortable: true, align: 'left', value: 'planowanaDataRealizacji'},
        { text: 'Status', sortable: true, align: 'left', value: 'status'} ,
        { text: 'Rodzaj', sortable: false, align: 'left', value: 'rodzajPlanu'},
        { text: 'Terapeuta', sortable: false, align: 'left', value: 'therapistName'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      loading: false
    }
  },
  methods: {
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    getFormattedDate(val)
    {

      if(val) {
        let dj = dayjs(val)

        if (dj != null) {
          return dj.format("DD-MM-YYYY")
        } else {
          return ''
        }
      }
      return ''
    },
    getStatusDescription(status) {
      switch (status){
        case 0:
          return 'Wersja robocza';
        case 1:
          return 'Otwarty';
        case 2:
          return 'Zrealizowany';
        case 3:
          return 'Anulowany';
      }
      return '';
    },
    getRodzajOpis(rodzaj) {
      switch (rodzaj){
        case 0:
          return 'Nowy plan';
        case 1:
          return 'Ewaulacja planu';
      }
      return '';
    },
    dodajPlan()
    {
      this.edytowanyPlan = null
      this.title_edycja_tworzenie = 'Nowy plan terapii i zdrowienia'
      this.nowy_plan_dialog = true
    },
    getData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      this.loading = true

      planyTerapiiService.getPlany({
        Sorting: sortValue,
        SkipCount: (page-1) * itemsPerPage,
        MaxResultCount: itemsPerPage,
        ClientId: this.clientid
      }).then(result=>{
        this.items = result.data.result.items
        this.totalCount = result.data.result.totalCount
        this.loading = false
      }).catch(() => {
        this.showError('Bład pobierania planów zdrowienia i terapii')
        this.loading = false
      })

    },

    closeEdit() {
      this.nowy_plan_dialog = false
      this.getData()
    },
    editPlan(plan) {
      this.edytowanyPlan = plan
      this.title_edycja_tworzenie = 'Edycja planu terapii i zdrowienia'
      this.nowy_plan_dialog = true
    },
    drukujPlan(id)
    {
      planyTerapiiService.getPlanTerapiiPrint(id).then((result)=> {
        let res = result.data.result
        let a = document.createElement("a"); //Create <a>
        a.href = "data:application/octet-stream;base64," + res.fileBase64; //Image Base64 Goes here
        a.download = res.fileName; //File name Here
        a.setAttribute('target','_blank');
        a.click(); //Downloaded file
      }).catch(() => {
        this.showError('Bład pobierania plany terapii do wydruku')
      })
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dodajPlan" v-if="$can('do','POKO_PlanyZdrowieniaEdycja')">Nowy plan terapii</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="totalCount"
            :loading="loading"
            :footer-props="{itemsPerPageOptions:[50,100,200,500],}"
            class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{getFormattedDate(props.item.planowanaDataRealizacji)}}</td>
              <td>{{getStatusDescription(props.item.status)}}</td>
              <td>{{getRodzajOpis(props.item.rodzajPlanu)}}</td>
              <td>{{props.item.therapistName}}</td>
              <td>
                <v-icon small class="mr-2" @click="editPlan(props.item) && $can('do','POKO_PlanyZdrowieniaEdycja')" color="primary"  title="Sprawdz szczegóły planu terapii">fa-edit</v-icon>
                <v-icon small class="mr-2" @click="drukujPlan(props.item.id)" color="warning"  title="Drukuj">fa-print</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="nowy_plan_dialog">
      <v-dialog v-model="nowy_plan_dialog" fullscreen persistent>
        <v-card>
          <v-toolbar dark class="primary">
            <v-btn icon @click.native="nowy_plan_dialog = false" dark>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title_edycja_tworzenie}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <PlanZdrowieniaEdit :clientid="clientid" :edytowany="edytowanyPlan" v-if="nowy_plan_dialog" @close="closeEdit"></PlanZdrowieniaEdit>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>